import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Text } from '../pulsechain_components/Text';
import { Link } from '../pulsechain_components/Link';

const BlackBackground = styled.div`
  background-color: ${(p: { theme: any }) => p.theme.gray.dark};
  min-height: 100vh;
`;
const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const LogoText = styled(Text as any)`
  font-weight: bold;
  align-items: center;
`;
const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 400px;
  height: 400px;

  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;

  /*this to solve "the content will not be cut when the window is smaller than the content": */
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
`;

export const NotFoundPage = (): JSX.Element => {
  return (
    <BlackBackground>
      <Content>
        <LogoContainer>
          <LogoText className="mt20" center size="large">
            PulseChain Staking Launchpad
          </LogoText>
        </LogoContainer>
        <Text center className="mt20">
          <FormattedMessage defaultMessage="Sorry, this page does not exist." />
          <Link primary className="mt20" to="/">
            {' '}
            <FormattedMessage defaultMessage="Launchpad home" />
          </Link>
        </Text>
      </Content>
    </BlackBackground>
  );
};
